import * as React from 'react';
import styled from 'styled-components';
import colors from '../colors';

export type SizeType = 'large' | 'medium' | 'small' | number;
export interface Props {
  readonly size?: SizeType;
  readonly color?: string;
}

const SMALL = 15;
const MEDIUM = 50;
const LARGE = 80;

const StyledSpinner = styled.div<{size?: any}>`
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-left-color: ${({color}) => color};
  animation: loader-spin 1s infinite linear;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;

  ${({size}) =>
    size === 'large'
      ? `&{
        width: ${LARGE}px;
        height: ${LARGE}px;
      }`
      : size === 'small'
      ? `&{
        width: ${SMALL}px;
        height: ${SMALL}px;
      }`
      : size === 'medium'
      ? `&{
        width: ${MEDIUM}px;
        height: ${MEDIUM}px;
      }`
      : `&{
        width: ${size}px;
        height: ${size}px;
      }`}

  @keyframes loader-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Spinner: React.FunctionComponent<Props> = ({
  size = 'medium',
  color = colors.gray300,
  ...rest
}) => <StyledSpinner size={size} color={color} {...rest} />;

export default Spinner;
